import React, { FC } from "react";
import classNames from "classnames";

import styles from "./styles.module.css";

interface ImageBoxProps {
  width: number;
  height: number;
  photo: string;
  text?: string;
  className?: string;
  handleClick?: () => void;
}

export const ImageBox: FC<ImageBoxProps> = ({
  width,
  height,
  className,
  text,
  photo,
  handleClick,
}) => (
  <div
    className={`${classNames(className, styles.container)} w-${width} overflow-hidden`}
    onClick={handleClick}
  >
    <img
      className={`w-${width} h-${height} rounded`}
      style={{ width, height, objectFit: "cover" }}
      src={photo}
      alt="image"
    />
    {!!text && (
      <div className="mt-1 text-sm px-3 font-medium text-ellipsis text-nowrap overflow-hidden max-w-full">
        {text}
      </div>
    )}
  </div>
);
